import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./GlitchTheme.css";
import GalaxyBackground from "./GalaxyBackground";
import imgCDFront from "./assets/wonder² cd.png";
import imgCDBack from "./assets/wonder² - cd atrás.png";
import moletomW2 from "./assets/moletomw2.png";
import moletomW3 from "./assets/moletomw3.png";
import { ProductDetail } from "./ProductPage";

interface Product {
  id: number;
  sku: string;
  name: string;
  price: number;
  priceFormatted: string;
  tag: string;
  tagVariant?: "default" | "limited" | "featured" | "soldout";
  stock: string;
  stockLimit?: number;
  category: string;
  album: "W2";
  delay: string;
  image?: string;
  hoverImage?: string;
  preOrder?: boolean;
  unavailable?: boolean;
}

const PRODUCTS: Product[] = [
  // ── STANDARD — em breve ─────────────────────────────────
  // {
  //   id: 10,
  //   sku: "W2-CD-STD",
  //   name: "Wonder² | Standard Edition (CD)",
  //   price: 35,
  //   priceFormatted: "R$ 35,00",
  //   tag: "PRÉ-VENDA",
  //   tagVariant: "featured",
  //   stock: "PRÉ-VENDA",
  //   category: "ÁUDIO",
  //   album: "W2",
  //   delay: "0.05s",
  //   preOrder: true,
  //   image: imgCDFront,
  //   hoverImage: imgCDBack,
  // },

  {
    id: 11,
    sku: "W2-CD-SGN",
    name: "Wonder² | Standard Signed Edition (CD)",
    price: 40,
    priceFormatted: "R$ 40,00",
    tag: "PRÉ-VENDA",
    tagVariant: "featured",
    stock: "PRÉ-VENDA",
    stockLimit: 50,
    category: "ÁUDIO",
    album: "W2",
    delay: "0.05s",
    preOrder: true,
    image: imgCDFront,
    hoverImage: imgCDBack,
  },

  // ── COTTON CANDY E GOLDEN KITE — não anunciadas ainda ──────────────────
  // {
  //   id: 12,
  //   sku: "W2-CD-CCE",
  //   name: "COTTON CANDY EDITION — wonder²",
  //   price: 55,
  //   priceFormatted: "R$ 55,00",
  //   tag: "LIMITED · 20 UN",
  //   tagVariant: "limited",
  //   stock: "LIMITADO",
  //   stockLimit: 20,
  //   category: "ÁUDIO",
  //   album: "W2",
  //   delay: "0.15s",
  //   preOrder: true,
  //   image: imgCDFront,
  // },
  // {
  //   id: 13,
  //   sku: "W2-CD-GKE",
  //   name: "GOLDEN KITE EDITION — wonder²",
  //   price: 55,
  //   priceFormatted: "R$ 55,00",
  //   tag: "LIMITED · 20 UN",
  //   tagVariant: "limited",
  //   stock: "LIMITADO",
  //   stockLimit: 20,
  //   category: "ÁUDIO",
  //   album: "W2",
  //   delay: "0.20s",
  //   preOrder: true,
  //   image: imgCDFront,
  // },
  // ───────────────────────────────────────────────────────────────────────

  {
    id: 14,
    sku: "W2-MOL-GAL",
    name: "MOLETOM GALÁXIA — wonder²",
    price: 200,
    priceFormatted: "R$ 200,00",
    tag: "EM BREVE",
    tagVariant: "soldout",
    stock: "EM BREVE",
    category: "VESTUÁRIO",
    album: "W2",
    delay: "0.10s",
    image: moletomW2,
    unavailable: true,
  },
  {
    id: 15,
    sku: "W2-MOL-TIG",
    name: "MOLETOM TIGRE — wonder²",
    price: 200,
    priceFormatted: "R$ 200,00",
    tag: "EM BREVE",
    tagVariant: "soldout",
    stock: "EM BREVE",
    category: "VESTUÁRIO",
    album: "W2",
    delay: "0.15s",
    image: moletomW3,
    unavailable: true,
  },
];

const FILTERS = ["TODOS", "ÁUDIO", "VESTUÁRIO"];

interface MerchProps {
  cart: (ProductDetail & { quantity: number })[];
  onAddToCart: (product: ProductDetail) => void;
}

const Merch: React.FC<MerchProps> = ({ cart, onAddToCart }) => {
  const navigate = useNavigate();
  const [activeFilter, setActiveFilter] = useState("TODOS");
  const [addedId, setAddedId] = useState<number | null>(null);
  const [limitReachedId, setLimitReachedId] = useState<number | null>(null);
  const [hoveredId, setHoveredId] = useState<number | null>(null);

  const getCartQty = (productId: number) =>
    cart.find((i) => i.id === productId)?.quantity ?? 0;
  const isAtLimit = (product: Product) =>
    product.stockLimit !== undefined &&
    getCartQty(product.id) >= product.stockLimit;

  const handleAddToCart = (e: React.MouseEvent, product: Product) => {
    e.stopPropagation();
    if (product.unavailable) return;
    if (isAtLimit(product)) {
      setLimitReachedId(product.id);
      setTimeout(() => setLimitReachedId(null), 2000);
      return;
    }
    onAddToCart(product as unknown as ProductDetail);
    setAddedId(product.id);
    setTimeout(() => setAddedId(null), 1200);
  };

  const filteredProducts = PRODUCTS.filter((p) => {
    if (activeFilter === "TODOS") return true;
    return p.category === activeFilter;
  });

  return (
    <div className="wonder-page wonder-galaxy galaxy-subpage">
      <GalaxyBackground />

      <div
        className="galaxy-subpage-content merch-page"
        style={{ background: "transparent" }}
      >
        <header className="glitch-wrapper merch-header">
          <h1 className="glitch-title galaxy-title-text" data-text="LOJA">
            LOJA
          </h1>
          <p className="merch-subtitle galaxy-subtitle blur-text-reveal">
            PRODUTOS OFICIAIS // TERMINAL DO SISTEMA
          </p>
        </header>

        <div className="preorder-banner">
          <span className="preorder-banner-dot" />
          <span>PRÉ-VENDA WONDER² ABERTA — ENTREGA A PARTIR DE 08.07.2026</span>
          <span className="preorder-banner-dot" />
        </div>

        <div className="merch-filters">
          {FILTERS.map((f) => (
            <button
              key={f}
              onClick={() => setActiveFilter(f)}
              className={`filter-btn galaxy-filter-btn ${
                activeFilter === f ? "active galaxy-filter-active" : ""
              }`}
            >
              {f === "TODOS" ? f : `SYS.${f}`}
            </button>
          ))}
        </div>

        <div className="product-grid">
          {filteredProducts.map((product) => (
            <div
              key={`${product.id}-${activeFilter}`}
              className="product-card galaxy-product-card card-hover"
              style={{ animationDelay: product.delay, cursor: "pointer" }}
              onClick={() => navigate(`/merch/${product.sku}`)}
            >
              <span
                className={`product-tag tag-${product.tagVariant ?? "default"}`}
              >
                {product.tag}
              </span>
              <div className="product-sku galaxy-sku">
                &gt; SKU:{product.sku}
              </div>

              <div
                className="product-img-wrap galaxy-img-wrap"
                onMouseEnter={() => setHoveredId(product.id)}
                onMouseLeave={() => setHoveredId(null)}
                style={{ position: "relative", overflow: "hidden" }}
              >
                {product.image ? (
                  <>
                    <img
                      src={product.image}
                      alt={product.name}
                      className="product-img"
                      style={{
                        opacity: product.unavailable
                          ? 0.4
                          : hoveredId === product.id && product.hoverImage
                          ? 0
                          : 1,
                        transition: "opacity 0.4s ease",
                        position: "absolute",
                        inset: 0,
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                      }}
                    />
                    {product.hoverImage && (
                      <img
                        src={product.hoverImage}
                        alt={`${product.name} — atrás`}
                        className="product-img"
                        style={{
                          opacity:
                            hoveredId === product.id
                              ? product.unavailable
                                ? 0.4
                                : 1
                              : 0,
                          transition: "opacity 0.4s ease",
                          position: "absolute",
                          inset: 0,
                          width: "100%",
                          height: "100%",
                          objectFit: "cover",
                        }}
                      />
                    )}
                  </>
                ) : (
                  <div className="product-img-placeholder galaxy-img-placeholder">
                    [ W2_IMG ]
                  </div>
                )}
              </div>

              <div className="product-info">
                <h3 className="product-name galaxy-product-name">
                  {product.name}
                </h3>
                <p className="product-stock">
                  SYS.ESTOQUE:{" "}
                  <span
                    className={
                      product.unavailable
                        ? "neon-red"
                        : product.stock === "LIMITADO"
                        ? "neon-purple"
                        : "neon-green"
                    }
                  >
                    {product.stock}
                    {product.stockLimit && !product.unavailable
                      ? ` · ${product.stockLimit} UN`
                      : ""}
                  </span>
                </p>
                <div className="product-footer galaxy-product-footer">
                  <p className="product-price galaxy-accent">
                    {product.priceFormatted}
                  </p>
                  <button
                    className={`add-btn galaxy-add-btn ${
                      product.unavailable
                        ? "soldout-btn"
                        : limitReachedId === product.id
                        ? "soldout-btn"
                        : addedId === product.id
                        ? "added"
                        : ""
                    }`}
                    onClick={(e) => handleAddToCart(e, product)}
                    disabled={product.unavailable || isAtLimit(product)}
                  >
                    {product.unavailable
                      ? "EM BREVE"
                      : limitReachedId === product.id
                      ? "LIMITE!"
                      : isAtLimit(product)
                      ? "ESGOTADO"
                      : addedId === product.id
                      ? "ADICIONADO ✓"
                      : "ADICIONAR"}
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Merch;
